import { ReactNode } from "react";
import styles from "./ModalColumn.module.css";

type ModalColumnProps = {
  children: ReactNode;
  gap: "small" | "medium" | "big";
  className?: string | undefined;
  testId?: string;
};

function ModalColumn({ children, gap, className, testId }: ModalColumnProps) {
  const combinedClassName = className
    ? `${styles[gap]} ${className}`
    : styles[gap];
  return (
    <div className={combinedClassName} data-testid={testId}>
      {children}
    </div>
  );
}

export default ModalColumn;
